export default (price) => price / 100;
